// TODO: backward compatibility, maybe remove the file?
export * from '@localstack/constants';
